import { PersonPinCircleOutlined } from "@mui/icons-material";
import { Card, Container, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import CustomLoader from "src/commonComponents/CustomLoader";
import Page from "src/components/Page";
import { Routes } from "src/constant/api_url";
import { fetchAchievementPinList } from "src/utils/common";

export default function Index() {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.a_p_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.name,
      sortable: true
    },
    {
      name: "Image",
      selector: (row) => (
        <>
          <img
            title={row.name}
            src={`${Routes.API_HOSTNAME}achievement-pin-image/${row?.image}`}
            width="90"
            alt={row.name}
          />
        </>
      ),
      sortable: true
    },
    {
      name: "Pin Description",
      selector: (row) => row?.description,
      wrap: true,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "100px",
      selector: (row) => (
        <>
          <Tooltip title="Pin Eligible Users">
            <IconButton
            //   onClick={() => {
            //     setPinData({
            //       name: row.name,
            //       a_p_id: row.a_p_id,
            //       pin_sequence: row.pin_sequence,
            //       file: row.image,
            //       status: row.status,
            //       description: row.description,
            //       p_price: row.p_price,
            //       p_city_price: row.p_city_price,
            //       add_pin_in_product: row.p_price !== null ? 1 : 0
            //     });
            //     toggleAddEditModal();
            //   }}
            >
              <PersonPinCircleOutlined color="success" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const getPinBadge = async () => {
    setIsLoading(true);
    let res = await fetchAchievementPinList();
    setIsLoading(false);
    setTableData(res);
  };
  useEffect(() => {
    getPinBadge();
  }, []);

  const selectedPin = state?.a_p_id
    ? (tableData ?? []).find((row) => row.a_p_id === state.a_p_id)
    : null;

  return (
    <>
      <Page title="Pin In Member | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Pin In Member
            </Typography>
          </Stack>

          {selectedPin && (
            <Stack direction="row" alignItems="center" spacing={2} mb={2}>
              <img
                src={`${Routes.API_HOSTNAME}achievement-pin-image/${selectedPin?.image}`}
                width="48"
                alt={selectedPin?.name}
              />
              <Typography variant="h6">Selected Pin: {selectedPin?.name}</Typography>
            </Stack>
          )}

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
              conditionalRowStyles={[
                {
                  when: (row) => selectedPin && row.a_p_id === selectedPin.a_p_id,
                  style: { backgroundColor: "#e5eeff" }
                }
              ]}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
